/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { DeliveryDtoUpdate } from '../../models/delivery-dto-update';
import { DeliveryItem } from '../../models/delivery-item';

export interface DeliveryControllerUpdate$Params {
  id: number;
      body: DeliveryDtoUpdate
}

export function deliveryControllerUpdate(http: HttpClient, rootUrl: string, params: DeliveryControllerUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: DeliveryItem;
}>> {
  const rb = new RequestBuilder(rootUrl, deliveryControllerUpdate.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: DeliveryItem;
      }>;
    })
  );
}

deliveryControllerUpdate.PATH = '/delivery/{id}';
